var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90883 18.7075C9.52667 19.0897 9.52667 19.709 9.90883 20.0911C10.291 20.4733 10.9103 20.4733 11.2925 20.0911L15 16.3836L18.7075 20.0911C19.0897 20.4733 19.709 20.4733 20.0912 20.0911C20.4733 19.709 20.4733 19.0897 20.0912 18.7075L16.3836 15L20.0912 11.2924C20.4733 10.9103 20.4733 10.291 20.0912 9.9088C19.709 9.52664 19.0897 9.52664 18.7075 9.9088L15 13.6163L11.2925 9.9088C10.9103 9.52664 10.291 9.52664 9.90883 9.9088C9.52668 10.291 9.52668 10.9103 9.90883 11.2924L13.6164 15L9.90883 18.7075Z",
    fill: "#332F21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.42e2c7bed1439937a861a9d76cd6a2ae.svg";
export { ForwardRef as ReactComponent };